import {useEffect} from 'react';
import {scrollToTop} from '../lib/utils';

export function useScrollToTop() {
  useEffect(() => {
    scrollToTop();
  }, []);
}
